export const MUI_ACCORDION_STYLES = {
	width: '100%',
	alignItems: 'baseline !important',
	'& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root': {
		margin: '9px !important',
	},
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(180deg)',
	},
	'& .Mui-expanded': {
		background: '#F8FAFC !important',
		marginTop: '16px',
	},
};
